export default __webpack_public_path__ + "static/media/0Y.dbfd6ac8.png";